// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import {
  updateNotificationDestination,
  UpdateNotificationDestinationRequest,
} from 'services/WebHooksService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useUpdateNotificationDestinationMutation = () => {
  return useMutation({
    mutationFn: updateNotificationDestination,
    onError(error: BaseErrorResponse, data: UpdateNotificationDestinationRequest) {
      logSentryError('Error from useUpdateNotificationDestinationMutation', error, data)
    },
  })
}
